/**
 * Timeout Configuration Defaults
 *
 * These are fallback values. The actual values should come from the RadarConfig API.
 * Use the `useTimeoutConfig` hook to get the configured values.
 */

/**
 * Default idle timeout before deselecting shot and showing the "Take your shot" overlay.
 * Default: 20 seconds
 */
export const DEFAULT_IDLE_TIMEOUT_MS = 20 * 1000;

/**
 * Default inactivity timeout before showing "Still there?" modal
 * Default: 4 minutes
 */
export const DEFAULT_INACTIVITY_TIMEOUT_MS = 4 * 60 * 1000;

/**
 * Default modal response timeout - time user has to respond to "Still there?" modal
 * If no response within this time, session will end automatically
 * Default: 1 minute
 */
export const DEFAULT_MODAL_RESPONSE_TIMEOUT_MS = 1 * 60 * 1000;

/**
 * Default auto-claim delay - time to wait after a shot lands before
 * automatically opening the claim overlay
 * Default: 5 seconds
 */
export const DEFAULT_AUTO_CLAIM_DELAY_MS = 5 * 1000;

/**
 * Default auto-claim close timeout - time before the claim overlay auto-closes
 * when opened via auto-claim (consented shot)
 * Default: 20 seconds
 */
export const DEFAULT_AUTO_CLAIM_CLOSE_TIMEOUT_MS = 20 * 1000;

/**
 * Default timeout for the Radar consent POST request.
 * Default: 5 seconds
 */
export const DEFAULT_RADAR_CONSENT_TIMEOUT_MS = 5 * 1000;

/**
 * Delay after final measurement before POST /api/Consent. Radar needs
 * consent slightly after the final measurement, not immediately.
 */
export const RADAR_CONSENT_REPORT_DELAY_MS = 5 * 1000;
